/** Default `FieldExplanationIcon` horizontal offset beside dropdown fields. */
export const DROPDOWN_HELP_ICON_OFFSET_PX = 16;

/** Offset when the quick-add button is visible beside the dropdown. */
export const DROPDOWN_HELP_ICON_OFFSET_ADD_PX = 56;

/** Offset when both quick-add and edit buttons are visible beside the dropdown. */
export const DROPDOWN_HELP_ICON_OFFSET_ADD_EDIT_PX = 96;

/** Offset when find-area, quick-add, and edit buttons are all visible beside the dropdown. */
export const DROPDOWN_HELP_ICON_OFFSET_FIND_AREA_ADD_EDIT_PX = 144;

interface IGetDropdownHelpIconOffsetPxParams {
  hasAddButton: boolean;
  hasEditButton: boolean;
  hasFindAreaButton?: boolean;
}

export const getDropdownHelpIconOffsetPx = ({
  hasAddButton,
  hasEditButton,
  hasFindAreaButton,
}: IGetDropdownHelpIconOffsetPxParams): number => {
  if (hasFindAreaButton && hasAddButton && hasEditButton) {
    return DROPDOWN_HELP_ICON_OFFSET_FIND_AREA_ADD_EDIT_PX;
  }

  if (hasFindAreaButton && (hasAddButton || hasEditButton)) {
    return DROPDOWN_HELP_ICON_OFFSET_ADD_EDIT_PX;
  }

  if (hasFindAreaButton) {
    return DROPDOWN_HELP_ICON_OFFSET_ADD_PX;
  }

  if (hasAddButton && hasEditButton) {
    return DROPDOWN_HELP_ICON_OFFSET_ADD_EDIT_PX;
  }

  if (hasAddButton || hasEditButton) {
    return DROPDOWN_HELP_ICON_OFFSET_ADD_PX;
  }

  return DROPDOWN_HELP_ICON_OFFSET_PX;
};
